import type { Env } from '@bank/utils';

export const ALLOWED_ORIGINS = Object.freeze([
  'https://signature.signicat.com',
  'https://preprod.signicat.com',
  'https://www-t.storebrand.no',
  'https://www.storebrand.no',
]);

const getOrigin = (url: string): string => new URL(url).origin;

export interface NavigateToExternalOptions {
  assign?: (url: string) => void;
  env?: Env;
}

export const navigateToExternal = (
  url: string,
  { assign, env }: NavigateToExternalOptions = {},
): void => {
  const origin = getOrigin(url);
  const isAllowedOrigin =
    env === 'dev' ? true : ALLOWED_ORIGINS.includes(origin);

  if (!isAllowedOrigin) {
    throw new Error(`ExternalNavigation with invalid origin: ${origin} ${url}`);
  }

  if (assign) {
    assign(url);
  } else {
    window.location.assign(url);
  }
};
